<template>
    <span v-if="latLon && !hideText" class="link item-detail-text" style="color: #0b4b8f" @click.stop="dialogVisible = true">
        Google Street View <font-awesome-icon icon="up-right-from-square" class="px-1"/>
    </span>
    <base-modal v-if="dialogVisible" @close="closeDialog" @ok="openStreetView" :title="$t('common.open_streetview')">
        <div class="mb-3">{{ $t('common.open_streetview_descr')}}</div>
    </base-modal>
</template>

<script>
import BaseModal from "@/components/BaseModal";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    name: 'GoogleStreetViewLink',
    components: {FontAwesomeIcon, BaseModal},
    props: {
        latLon: null,
        hideText: false
    },
    data: function () {
        return {
            dialogVisible: false
        }
    },
    emits: ['dialogClosed'],
    methods: {
        closeDialog() {
            this.dialogVisible = false
            this.$emit('dialogClosed')
        },

        openStreetView() {
            if (this.latLon) {
                const lat = this.latLon.lat.toFixed(5)
                const lon = this.latLon.lon.toFixed(5)
                const url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lon}`;
                window.open(url, "_blank");
            }
            this.closeDialog()
        },

        showPrompt() {
            this.dialogVisible = true
        }
    }
}
</script>
